module.exports = __webpack_public_path__ + "img/sna.d01c1fc2.png";